import {Component, computed, inject, input} from '@angular/core';
import {Button} from "primeng/button";
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Checkbox} from 'primeng/checkbox';
import {DatePipe} from '@angular/common';
import {TravellerDetails} from '../../../../api';
import {TaToastComponent} from '../../ta-toast/ta-toast.component';
import {TaAppStore} from '../../../../state/clcta-store';

@Component({
  selector: 'deduction-auth-modal',
  imports: [
    Button,
    ReactiveFormsModule,
    FormsModule,
    Checkbox,
    DatePipe,
    TaToastComponent,
  ],
  templateUrl: './deduction-auth-modal.component.html',
  styleUrl: './deduction-auth-modal.component.scss'
})
export class DeductionAuthModalComponent {
  traveller = input<TravellerDetails>();

  store = inject(TaAppStore);

  // A TA with a booking officer is a delegate TA, so the authority is being accepted on the
  // traveller's behalf and the template renders the delegate version of the document.
  isDelegateTa = computed<boolean>(() => !!this.store.taSubmission()?.delegate);
  bookingOfficerName = computed<string>(() => this.store.taSubmission()?.delegate?.name ?? '');

  travellerName = computed<string>(() =>
    ((this.traveller()?.details?.firstName ?? '') + ' ' + (this.traveller()?.details?.surname ?? '')).trim()
  );

  formData = {
    additionalComments: '',
    authorisation: false,
    authorisationDate:  new Date(),
  };

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

  closeDialog(data: any): void {
    this.ref.close(data);
  }
}